import {gsap} from "gsap";

export default function ui(){
    const toggleBtn = document.getElementById('toggleBtn')
    const arrow = document.getElementById('arrow')
    const sidebar = document.getElementById('sidebar')
    const materialRadios = document.querySelectorAll('input[name="material"]')
    const panels = document.querySelectorAll(".panel")
    const accordions = document.querySelectorAll('.accordion');

    const materialsWood = document.querySelector('.materials-wood')


    let isOpen = true;

    toggleBtn.addEventListener('click', () => {
        if (isOpen) {
            gsap.to(sidebar, {
                x: -300,
                duration: 0.3,
                ease: 'power2.out'
            })

            gsap.to(arrow, {
                rotate: 180,
                transformOrigin: '50% 50%',
                duration: 0.3,
                ease: 'power2.out'
            })

            gsap.to(toggleBtn, {
                x: -300,
                duration: 0.3,
                ease: 'power2.out'
            })
        } else {
            gsap.to(sidebar, {
                x: 0,
                duration: 0.3,
                ease: 'power2.out'
            })

            gsap.to(arrow, {
                rotate: 0,
                transformOrigin: '50% 50%',
                duration: 0.3,
                ease: 'power2.out'
            })

            gsap.to(toggleBtn, {
                x: 0,
                duration: 0.3,
                ease: 'power2.out'
            })
        }

        isOpen = !isOpen
    });

    accordions.forEach((btn, i) => {
        const symbol = btn.querySelector('.symbol')

        const dataSpan = btn.querySelector('.accordion-data')
        const radios = panels[i].querySelectorAll('input[type="radio"]')

        radios.forEach(radio => {
            radio.addEventListener('change', () => {
                if (!radio.dataset.text) return
                dataSpan.textContent = radio.dataset.text

                if (radio.name === 'material') {
                    materialsWood.textContent = radio.dataset.text
                }
            })
        })

        const checked = panels[i].querySelector('input[type="radio"]:checked')
        if (checked?.dataset.text) {
            dataSpan.textContent = checked.dataset.text
        }

        panels[i].classList.toggle("open")
        panels[i].style.height = "auto"
        symbol.textContent = '−'

        btn.addEventListener("click", () => {
            panels[i].classList.toggle("open")

            if(panels[i].classList.contains("open")){
                panels[i].style.height = "auto"
                symbol.textContent = '−'

                return
            }

            panels[i].style.height = 0
            symbol.textContent = '+'
        });
    });

    return{
        materialRadios
    }
}